export default "__VITE_PUBLIC_ASSET__48daaee7__"